//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FabricSearch from "@/components/q-fabric-search.vue";
import { date } from "quasar";
import { APP_DATE_DOT_FORMAT, APP_DATE_HOUR_MIN_FORMAT, APP_DATE_DOT_DMY_FORMAT } from "@/assets/js/appConfig";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import { eventBus, setPluginIcon, copyToClipboard, formatTimeToSend, convertAndFormatTimeToLocal } from "@/assets/js/appFunc";
import { mapActions, mapGetters } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import TabComponents from "../mixins/tab-components";

export default {
    components: {
        FabricSearch,
        AQInput,
        AQCard,
        AQButton,
        AQMenu,
        AQDialog,
        AQChip,
        AQBadge
    },
    mixins: [TabComponents],
    props: {
        instanceID: {
            type: String,
            default: ""
        },
        instanceName: {
            type: String,
            default: ""
        },
        systemStatus: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            APP_DATE_DOT_FORMAT,
            searchCom: "",
            fromDateCom: "",
            toDateCom: "",
            commentsExist: true,
            commentsList: null,
            showLoadMoreDocBtn: false,
            noFromDateComFound: false,
            noToDateComFound: false,
            showClearIconFrom: true,
            showClearIconTo: true,
            payload: null,
            openDialog: false,
            commentsPayload: {
                dateFrom: "",
                dateTo: "",
                generalSearch: "",
                page: 0,
                size: 5,
                sortDirection: "DESC",
                sortField: "execStartDate",
                processInstanceId: this.instanceID
            },
            actionMenu: [],
            optionsMenuDownload: [
                {
                    value: "copy",
                    label: this.$t("admin.processInspector.copy")
                },
                {
                    value: "delete",
                    label: this.$t("documents.delete")
                }
            ]

        };
    },
    computed: {
        ...mapGetters("admin", ["getProcessInspectorById"])

    },
    watch: {
        toDateCom: {
            handler(newValue) {
                this.updateDate(newValue);
                this.showClearIconFunc(newValue, "toStartDate");
            }
        },
        fromDateCom: {
            handler(newValue) {
                this.updateDate(newValue);
                this.showClearIconFunc(newValue, "fromStartDate");
            }
        },
        systemStatus: {
            handler(newValue) {
                this.optionsMenuDownload[1].itemDisabled = ["RUNNING", "FAILED"].includes(newValue);
            },
            immediate: true
        }
    },
    beforeDestroy() {
        eventBus.$off("commentsRefreshTab");
    },
    mounted() {
        this.getCommentsDetails();
        eventBus.$on("commentsRefreshTab", () => {
            this.getCommentsDetails();
        });
    },

    methods: {
        setPluginIcon,
        copyToClipboard,
        formatTimeToSend,
        convertAndFormatTimeToLocal,
        ...mapActions("admin", ["getComments", "deleteComment"]),

        optionSelected(item) {
            if (this.actionMenu[0].value === "copy") {
                this.copyToClipboard(item.comment);
            } else if (this.actionMenu[0].value === "delete") {
                this.payload = {
                    auditId: item.auditId,
                    processInstanceId: this.getProcessInspectorById.rootProcessInstanceId
                };
                this.openDialog = true;
            }
            this.actionMenu = [];
        },
        tooltipContent(message) {
            return this.$t("admin.processInspector.deleteMessage",
                { user: message.username, time: this.convertAndFormatTimeToLocal(message.execDate, APP_DATE_DOT_DMY_FORMAT) });
        },
        getChipProps(val) {
            const { userStatus, user, email, deleteEventDTO } = val;
            return {
                type: userStatus === "DISABLED" ? "userStatus" : "user",
                content: deleteEventDTO && !deleteEventDTO.username ? user.trim() || email : "user"
            };
        },
        okAction() {
            this.deleteComment(this.payload).then(data => {
                this.commentsList.forEach(item => {
                    if (item.auditId === this.payload.auditId) {
                        item.deleteEventDTO = data.data;
                    }
                });
                this.showNotify();
                this.$root.$emit("refreshTimeline");
            });
        },
        cancelAction() {
            this.openDialog = false;
        },
        showNotify() {
            this.$toast.showNotify({
                type: "success",
                message: this.$t("admin.processInspector.deleteConfirmation"),
                timeout: 500
            });
        },
        showClearIconFunc(value, state) {
            if (state === "fromStartDate") {
                this.showClearIconFrom = !!value;
            } else if (state === "toStartDate") {
                this.showClearIconTo = !!value;
            }
        },

        getCommentsDetails(loadMore) {
            if (!loadMore) {
                this.commentsPayload.page = 0;
            }
            this.getComments(this.commentsPayload).then(data => {
                this.commentsExist = data.data.list && data.data.list.length;
                this.commentsList = loadMore ? this.commentsList.concat(data.data.list) : data.data.list;
                this.showLoadMoreDocBtn = this.commentsPayload.size * (this.commentsPayload.page + 1) < data.data.totalElements;
            });
        },
        loadMoreItems() {
            ++this.commentsPayload.page;
            this.getCommentsDetails(true);
        },
        computedDateFormat(data) {
            const newDate = new Date(data);
            let formattedDate = date.formatDate(newDate, APP_DATE_DOT_FORMAT);
            formattedDate = formattedDate.replace(/ /g, " at ");
            return formattedDate;
        },
        searchTermDataDoc(value) {
            this.commentsPayload.generalSearch = value;
            this.commentsPayload.size = 5;
            this.getCommentsDetails();
        },
        updateDate(value) {
            const fromDate = this.fromDateCom;
            const toDate = this.toDateCom;
            const payload = this.commentsPayload;

            if (value) {
                if (fromDate && toDate) {
                    this.noFromDateComFound = false;
                    this.noToDateComFound = false;
                    payload.dateFrom = this.formatTimeToSend(
                        fromDate,
                        APP_DATE_HOUR_MIN_FORMAT
                    );
                    payload.dateTo = this.formatTimeToSend(
                        toDate,
                        APP_DATE_HOUR_MIN_FORMAT
                    );
                    payload.size = 5;
                    this.getCommentsDetails();
                } else if (!fromDate && toDate) {
                    this.noFromDateComFound = true;
                } else if (fromDate && !toDate) {
                    this.noToDateComFound = true;
                }
            }
        },
        updateModel(isFrom) {
            const fromDate = this.fromDateCom;
            const toDate = this.toDateCom;
            if (isFrom) {
                this.fromDateCom = "";
                if (toDate) {
                    this.noFromDateComFound = true;
                    this.noToDateComFound = false;
                } else {
                    this.noToDateComFound = false;
                    this.setPayloadOnUpdateModel();
                }
            } else {
                this.toDateCom = "";
                if (fromDate) {
                    this.noFromDateComFound = false;
                    this.noToDateComFound = true;
                } else {
                    this.noFromDateComFound = false;
                    this.setPayloadOnUpdateModel();
                }
            }
        },
        setPayloadOnUpdateModel() {
            this.noFromDateComFound = false;
            this.commentsPayload.dateFrom = "";
            this.commentsPayload.dateTo = "";
            this.commentsPayload.size = 5;
            this.getCommentsDetails();
        }

    }

};
